import { RichText as RichTextData } from '@silvertours/common-landingpages-view';
import { Ui } from '@silvertours/front-shared';

import { HasTextStyleRules } from './rule';
import { HasColumns } from '../rule';

import { RichTextWrapper } from './RichText.styles';

export type RichTextRules = HasColumns &
  HasTextStyleRules & {
    disableSnippetStyles?: boolean;
  };

export type RichTextProps = {
  content: RichTextData;
  rules?: RichTextRules;
};

export const RichText = (props: RichTextProps) => {
  const { content, rules = {} } = props;
  const { textStyle, columns, disableSnippetStyles } = rules;
  const isMultiColumn = columns && columns.length > 1;

  return (
    <RichTextWrapper rules={rules}>
      <Ui.RichText
        content={content}
        rules={{ textStyle, isMultiColumn, disableSnippetStyles }}
      />
    </RichTextWrapper>
  );
};
